<template>
  <div id="AboutMeQuote" :class="sectionClass">
    <div style="position: relative;;">
      <p
        >“Australian illustrator and designer Nathan Nankervis has made a name
        for himself amongst the creative industry as one of the next big things.
        Having bagged accolades for his work from across the world and worked
        with some of the biggest clients in the country.”</p
      >
      <p style="margin-top: 22px; font-size: smaller;">– Crave Media</p>

      <StickMe name="9" size="8" left="-8" top="-8" />
      <StickMe
        name="10"
        size="8"
        left="unset"
        top="unset"
        style="right: -16%; bottom: -16%;"
      />
    </div>
    <StickMe
      name="11"
      size="40"
      left="-55"
      top="11"
      uk-parallax="x: -10%,800%; y: 365%"
    />
  </div>
</template>

<script>
import { isMobile } from '@/helpers'
import StickMe from './StickMe.vue'

export default {
  components: {
    StickMe,
  },
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.section {
  width: 60%;
  margin-top: 44px;
  padding-bottom: 22%;
}

.sectionMobile {
  width: 75%;
  margin-top: 44px;
  padding-bottom: 22%;
  font-size: small;
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeQuote.vue